import { render, staticRenderFns } from "./SuggestionModal.vue?vue&type=template&id=6cf4926c&scoped=true&"
import script from "./SuggestionModal.vue?vue&type=script&lang=js&"
export * from "./SuggestionModal.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionModal.vue?vue&type=style&index=0&id=6cf4926c&prod&lang=css&"
import style1 from "./SuggestionModal.vue?vue&type=style&index=1&id=6cf4926c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4926c",
  null
  
)

export default component.exports